import Base from './Base';

export default class HubspotAttachment extends Base {
    constructor(item) {
        super(item);

        this.id = +item.id;
    }

    get isMeeting() {
        return this.type === 'meeting';
    }

    get isQuotes() {
        return this.type === 'quotes';
    }

    get ownerName() {
        const firstName = this.owner.first_name;
        const lastName = this.owner.last_name;

        if (firstName && lastName) {
            return `${firstName} ${lastName}`;
        }

        return firstName || lastName;
    }

    get name() {
        return this.title || '';
    }

    get desc() {
        if (this.isQuotes) return this.quote_amount;

        return '';
    }

    get source() {
        if (this.isMeeting) return `${this.url || 'not url'}`;
        if (this.isQuotes) return `${this.name} ${this.desc}`;

        return '';
    }
}
